import React from "react";
import { makeStyles, Typography, Box } from "@material-ui/core";
import level1 from "../img/level1.png";
import level2 from "../img/level2.png";
import level3 from "../img/level3.png";
import level4 from "../img/level4.png";

const useStyles = makeStyles((theme) => ({
  headLine: {
    color: "#0c3c5c",
    textAlign: "center",
    fontSize: 30,
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
  },
  headContent: {
    color: "#0c3c5c",
    textAlign: "center",
    fontSize: 20,
    fontWeight: "bold",
    marginBottom: theme.spacing(4),
  },
  gridContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexWrap: "wrap",
    gap: "0", // no gap at all
    margin: 0,
    padding: 0,
  },
  gridItem: {
    flex: "0 1 25%", // exactly 25% each
    maxWidth: "25%",
    padding: 0, // remove padding
    margin: 0, // remove margin
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      flex: "0 1 75%",
      maxWidth: "75%",
    },
  },
  image: {
    width: "100%",
    height: "auto",
    display: "block", // prevents inline image spacing
    userSelect: "none",
    pointerEvents: "none",
  },
}));

export default function SwimJourney() {
  const classes = useStyles();

  const levels = [
    { src: level1, alt: "level1" },
    { src: level2, alt: "level2" },
    { src: level3, alt: "level3" },
    { src: level4, alt: "level4" },
  ];

  return (
    <div>
      <Typography className={classes.headLine}>
        Swim Journey – Learn at Your Own Pace
      </Typography>
      <Typography className={classes.headContent}>
        At FL Swimming, we offer fun and well-structured swim classes that help
        every swimmer learn at a pace that’s right for them. Whether your child
        is just starting out or working toward more advanced skills, our
        programs are here to support steady progress — and make sure they enjoy
        the water along the way.
      </Typography>

      <Box className={classes.gridContainer}>
        {levels.map((level) => (
          <div key={level.alt} className={classes.gridItem}>
            <img src={level.src} alt={level.alt} className={classes.image} />
          </div>
        ))}
      </Box>
    </div>
  );
}
